import React from "react";
import "../../index.css";
import { Link } from "react-router";
import { Tooltip } from "react-tooltip";
import secondcoming from '../../Assets/Img/secondcoming.jpg'

const Chap6 = () => {
  return (
    <div className="chapter-container">

      <div className="chapterFooter">
        <Link to="/Chap5">Previous</Link>
        <Link to="/">Home</Link>
        <Link to="/Chap7">Next</Link>
      </div>

      <h1 className="chapterHeading">
        Chapter 6: Joseph Reveals the Events of the Latter Days
      </h1>

      <img src={secondcoming} className='image' alt='Christ appearing in the sky at second coming' />

    <div className="wrapper">


      <div className="paragraph">
        <p>
          Joseph’s message was clear. The Second Coming was on the horizon.
          Joseph revealed Christ’s words, “For this is a day of warning, and not
          a day of many words. For I, the Lord, am not to be mocked in the last
          days.” 
          <btn id="clickable1" className="footnote">1 </btn>
          <Tooltip anchorSelect="#clickable1" className="footnote-size" clickable>D&C 63:58.</Tooltip>
          
          In his prophetic role, Joseph revealed numerous things about
          the last days and Second Coming. Great and terrible events were to
          take place across the globe as prophesied in the Bible. Besides his
          own revelations, Joseph provided commentary on past prophets who
          prophesied of the last days such as Isaiah, Micah, Joel, Daniel,
          Malachi, etc. Joseph also had a lot to say about John’s Book of
          Revelation.
        </p>
      </div>

      <h2 className="headlinePadding">No One Knoweth, No, Not the Angels</h2>

      <div className="paragraph">
        <p>
          The New Testament quotes Christ saying, “Of that day, and hour, no one
          knoweth, no, not the angels of God in heaven, but my Father only.”
          Referring to Christ’s statement, Joseph said, “Did Christ speak this
          as a general principle throughout all generations? Oh no; he spoke in
          the present tense – no man that was then living upon the footstool of
          God knew the day or the hour.” Joseph continued, “To conclude
          otherwise would be a flat contradiction with other scriptures for the
          prophet (Amos) says that God will do nothing but what he will reveal
          it unto his servants the prophets.”
          <btn id="clickable2" className="footnote">2 </btn>
          <Tooltip anchorSelect="#clickable2" className="footnote-size" clickable>Discourse of Joseph Smith given at Nauvoo, Illinois, reported in “Journals of James Burgess, 1818-1904,” Church History Department.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Christ’s coming will catch many unaware. But this applies to the
          wicked and uninformed – not faithful Mormons following Joseph. Through
          him, the Mormons would generally know when Christ would appear. Christ
          would reveal to his prophet the work of directing the building of
          Zion, sanctifying the holy city, leading the Lost Ten Tribes to
          Jackson County, sending out the 144,000 to bring the righteous to
          Zion, establishing Zion in Jerusalem, and sending out the seven angels
          to cleanse the earth prior to his Second Coming.
        </p>
      </div>

      <h2 className="headlinePadding">Angel Moroni Announces Coming of the Lord</h2>

      <div className="paragraph">
        <p>
          In 1842, Joseph Smith relayed an account of the First Vision in a
          letter to John Wentworth of the Chicago Democrat newspaper. In this
          letter, he also presented the events of his 1823 meeting with the
          Angel Moroni. Joseph claimed that on September 21, 1823, the Angel
          Moroni told him about golden plates deposited in a hill near his home.
          Moroni quoted the Old Testament and New Testament, including Joel,
          Malachi, Isaiah, and Acts regarding latter-day events.
        </p>
      </div>

      <div className="paragraph">
        <p>
          Joseph wrote that Moroni quoted Malachi. “For behold, the day cometh
          that shall burn as an oven, and all the proud, yea, and all that do
          wickedly shall burn as stubble ... Behold, I will reveal unto you the
          Priesthood, by the hand of Elijah the prophet, before the coming of
          the great and dreadful day of the Lord.”
          <btn id="clickable3" className="footnote">3 </btn>
          <Tooltip anchorSelect="#clickable3" className="footnote-size" clickable>Joseph Smith History 1:37-39.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Moroni quoted Isaiah 11 stating, the knowledge of God will cover the
          earth in the Millennium and how Christ will raise an ensign to gather
          Israel, and said it was about to be fulfilled. Moroni quoted Acts
          3:22-23 “… precisely as they stand in our New Testament. He said that
          that prophet was Christ; but the day had not yet come when ‘they who
          would not hear his voice should be cut off from among the people,’ but
          soon would come.” 
          <btn id="clickable4" className="footnote">4 </btn>
          <Tooltip anchorSelect="#clickable4" className="footnote-size" clickable>Joseph Smith History 1:40.</Tooltip>
          
          Moroni “quoted the second chapter of Joel, from the
          twenty-eighth verse to the last. He also said that this was not yet
          fulfilled but was soon to be.” 
          <btn id="clickable5" className="footnote">5 </btn>
          <Tooltip anchorSelect="#clickable5" className="footnote-size" clickable>Joseph Smith History 1:41.</Tooltip>
          
          Joel’s theme is the building of Zion
          and the beginning of the manifestation of God’s glory upon Zion, with
          the abundant revelation and divine spiritual gifts.
        </p>
      </div>

      <div className="paragraph">
        <p>
          “… your sons and your daughters shall prophesy, your old men shall
          dream dreams, your young men shall see visions: And also upon the
          servants and upon the handmaids in those days will I pour out my
          spirit. And I will shew wonders in the heavens and in the earth,
          blood, and fire, and pillars of smoke. The sun shall be turned into
          darkness, and the moon into blood, before the great and the terrible
          day of the Lord come … for in Mount Zion and in Jerusalem shall be
          deliverance, as the Lord hath said, and in the remnant whom the Lord
          shall call.”
          <btn id="clickable6" className="footnote">6 </btn>
          <Tooltip anchorSelect="#clickable6" className="footnote-size" clickable>Joel 2:28–32.</Tooltip>
        </p>
      </div>

      <h2 className="headlinePadding">Putting the World on Notice</h2>

      <div className="paragraph">
        <p>
          In the opening section of the Doctrine and Covenants, Joseph revealed,
          “And the voice of warning shall be unto all people, by the mouths of
          my disciples, whom I have chosen in these last days.” 
          <btn id="clickable7" className="footnote">7 </btn>
          <Tooltip anchorSelect="#clickable7" className="footnote-size" clickable>D&C 1:4.</Tooltip>
          
          Christ
          continued, “That the fulness of my gospel might be proclaimed by the
          weak and the simple unto the ends of the world, and before kings and
          rulers.”
          <btn id="clickable8" className="footnote">8 </btn>
          <Tooltip anchorSelect="#clickable8" className="footnote-size" clickable>D&C 1:23.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          In 1841, Mormon apostle Parley Pratt did just that. In a letter to
          Queen Victoria of England, Parley bore testimony that the priesthood
          had been restored, and that it was time to gather the House of Israel
          to Zion in Jackson County – and establish of the ultimate government,
          the Kingdom of God. He begins his letter, “It has fallen to the lot of
          your Majesty not only to live in a most eventful period of the world,
          but to occupy a station the most conspicuous of that of any individual
          of the present age.” Parley continued, “Know assuredly that the world
          in which we live is on the eve of a revolution, more wonderful in its
          beginning – more rapid in its progress … and more important in its
          consequences, than any which man has yet witnessed upon the earth.”
        </p>
      </div>

      <div className="paragraph">
        <p>
          Parley spoke of Joseph’s restored gospel. “This restoration will take
          place by a series of miracles, signs, wonders, revelations, judgments,
          &c., which will far exceed the dispensation of Moses and the
          deliverance of Israel from Egyptian bondage.” Then Parley explained
          Daniel’s vision from the Old Testament and how it represents the
          Kingdom of God filling the earth, stating “From this it appears that
          this new kingdom will be established over the whole earth to the
          destruction of all other kingdoms.”
        </p>
      </div>

      <div className="paragraph">
        <p>
          Parley warns, “This restoration will take place by a series of
          miracles, signs, wonders, revelations, judgments, etc., which will far
          exceed the dispensation of Moses and the deliverance of Israel from
          Egyptian bondage.” Parley put a time to these events. “For the time
          soon cometh that the fullness of the wrath of God shall be poured out
          upon all the children of men; for he will not suffer that the wicked
          shall destroy the righteous.” Then he called the queen and people of
          England to repentance, “I must close this letter by forewarning the
          sovereign and people of England in the most affectionate manner, to
          repent and turn to the Lord with full purpose of heart.” Parley
          promised the Queen and people of England, “Now if the rulers, clergy
          and people of England hearken to this message, they shall have part in
          this glorious kingdom.”
          <btn id="clickable9" className="footnote">9 </btn>
          <Tooltip anchorSelect="#clickable9" className="footnote-size" clickable>Letter from Parley Pratt to Queen Victoria of England, written from Manchester, May 28, 1841.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Needless to say, Queen Victoria did not correspond to this Mormon
          apostle
        </p>
      </div>

      <h2 className="headlinePadding">The 1845 Mormon Proclamation</h2>

      <div className="paragraph">
        <p>
          With Joseph’s death in 1844, the burden of building Zion fell on the
          shoulders of the Mormon Apostles. Undeterred that a “voice of warning
          shall be unto all people, by the mouths of my disciples, whom I have
          chosen in these last days,” 
          <btn id="clickable10" className="footnote">10 </btn>
          <Tooltip anchorSelect="#clickable10" className="footnote-size" clickable>D&C 1:4.</Tooltip>
          
          the apostles issued a proclamation to the
          world in 1845. After all, for as Brigham stated, “The Kingdom of God …
          will control the kingdoms of the world”
          <btn id="clickable11" className="footnote">11 </btn>
          <Tooltip anchorSelect="#clickable11" className="footnote-size" clickable>Brigham Young, Journal of Discourses, June 3, 1855, vol. 2, p. 316-17.</Tooltip>
          
          and “bear rule over all the earth.” 
          <btn id="clickable12" className="footnote">12 </btn>
          <Tooltip anchorSelect="#clickable12" className="footnote-size" clickable>Brigham Young, Journal of Discourses, June 3, 1855, vol. 2, p. 316-17.</Tooltip>
          
          The world needed to be informed! Drawing a line in the sand,
          the Mormon apostles put world leaders on notice.
        </p>
      </div>

      <div className="paragraph">
        <p>
          “Know ye that the kingdom of God has come, as has been predicted by
          ancient prophets, and prayed for in all ages; even that kingdom which
          shall fill the whole earth, and shall stand for ever …
        </p>
      </div>

      <div className="paragraph">
        <p>
          “Being established in these last days for the restoration of all
          things spoken by the prophets since the world began, and in order to
          prepare the way for the coming of the Son of Man …
        </p>
      </div>

      <div className="paragraph">
        <p>
          “And we now bear witness that his coming is near at hand; and not many
          years hence, the nations and their kings shall see him coming in the
          clouds of heaven with power and great glory …
        </p>
      </div>

      <div className="paragraph">
        <p>
          The Mormon apostles issued a command that world leaders be baptized.
          “Therefore, we send unto you, with authority from on high, and command
          you all to repent and humble yourselves as little children before the
          majesty of the Holy One; and come unto Jesus with a broken heart and a
          contrite spirit, and be baptized …”
        </p>
      </div>

      <div className="paragraph">
        <p>
          Then the proclamation mentioned Zion in Jackson County. “And we
          further testify that the Lord has appointed a holy city and temple to
          be built on this continent, for the endowment and ordinances
          pertaining to the priesthood; and for the Gentiles, and the remnant of
          Israel to resort unto, in order to worship the Lord, and to be taught
          in his ways and walk in his paths …
        </p>
      </div>

      <div className="paragraph">
        <p>
          The Jews around the world were told to return to Palestine and rebuild
          the temple. “And we further testify that the Jews among all nations
          are hereby commanded, in the name of the Messiah, to prepare to return
          to Jerusalem in Palestine, and to rebuild that city and temple unto
          the Lord …
        </p>
      </div>

      <div className="paragraph">
        <p>
          Then the Mormon apostles command the “kings, rulers and people of the
          Gentiles” to join the Kingdom of God and bring their wealth to Zion.
          “And now, 0 ye kings, rulers, and people of the Gentiles, hear ye the
          word of the Lord, for this commandment is for you. You are not only
          required to repent and obey the gospel in its fulness, and thus become
          members or citizens of the kingdom of God; but you are also hereby
          commanded, in the name of Jesus Christ, to put your silver and your
          gold, your ships and steam-vessels, your railroad trains and your
          horses, chariots, camels, mules, and litters, into active use for the
          fulfilment of these purposes …
        </p>
      </div>

      <div className="paragraph">
        <p>
          Then the proclamation issued a warning. “As this work progresses in
          its onward course … no king, ruler, or subject, no community or
          individual, will stand neutral. All … will take sides either for or
          against the kingdom of God … Some will act the part of the venerable
          Jethro … or the noble Cyrus; and will aid and bless the people of God
          … While others will walk in the footsteps of a Pharaoh, or a Balak,
          and will harden their hearts, and fight against God and seek to
          destroy his people.”
          <btn id="clickable13" className="footnote">13 </btn>
          <Tooltip anchorSelect="#clickable13" className="footnote-size" clickable>Proclamation Of The Twelve Apostles Of The Church Of Jesus Christ, Of Latter-Day Saints, (New York, 1845), pp. 6-7.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Needless to say, the kings and rulers of the earth did not respond to
          the Mormons. For all the Mormons’ preaching and evangelizing, the
          message of the restored gospel was not resonating. With the exception
          of a few souls turning to Mormonism, the world was rejecting the
          Mormon gospel.
        </p>
      </div>

      </div>

      <div className="chapterFooter">
        <Link to="/Chap5">Previous</Link>
        <Link to="/">Home</Link>
        <Link to="/Chap7">Next</Link>
      </div>

    </div>
  );
};

export default Chap6;
